"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manual_set_current = void 0;
var api_1 = require("../../../api");
var manual_set_current = function (req) {
    return (0, api_1.apiPost)({
        endpoint: "v3/lot/manual_set_current",
        // data: formData,
        data: req,
    });
};
exports.manual_set_current = manual_set_current;
